import { KYC_STATUS_LOCAL } from "constants/status";
import FnxtSingletonApi from "./FnxtSingletonApi";

//UMBRELLA
export function umbrellaResendUser(uuid, newID) {
    return FnxtSingletonApi.post("/umbrellaResendUser", {
        uuid,
        ...(newID != null && { new_id: newID }),
    });
}

export function umbrellaResendInvestment(uid) {
    return FnxtSingletonApi.post("/umbrellaResendInvestment", { uid: uid });
}

export function umbrellaUpdateUsers({ userIds, isApprove }) {
    return FnxtSingletonApi.post("/umbrellaUpdateUsers", { user_uids: userIds, approved: isApprove });
}

export function umbrellaUpdateInvestments({ investmentIDs, isApprove }) {
    return FnxtSingletonApi.post("/umbrellaUpdateInvestments", { investment_uids: investmentIDs, approved: isApprove });
}

export function umbrellaUser({ userUIDs = [], offset = 0, limit = 10 }) {
    return FnxtSingletonApi.post("/umbrella/user", { user_uids: userUIDs, offset, limit });
}

export function umbrellaInvestment({ investmentUIDs = [], offset = 0, limit = 10 }) {
    return FnxtSingletonApi.post("/umbrella/investment", { investment_uids: investmentUIDs, offset, limit });
}

//KYC

export function getUserExists() {
    return FnxtSingletonApi.get("/kyc/v1/user/exists");
}

export function getKYCExists() {
    return FnxtSingletonApi.get("/kyc/v1/kyc/exists");
}

export function getKYC() {
    return FnxtSingletonApi.get("/kyc/v1/user");
}

export function getKYCCombined() {
    return FnxtSingletonApi.get("/kyc/v1/kyc");
}

export function submitKYC(payload, kycStatus) {
    if (kycStatus && kycStatus !== KYC_STATUS_LOCAL.INCOMPLETE) {
        return FnxtSingletonApi.patch("/kyc/v1/user", payload);
    } else {
        return FnxtSingletonApi.post("/kyc/v1/user", payload);
    }
}

export function updateKYC({ payload }) {
    return FnxtSingletonApi.post("/kyc/v1/user/", payload);
}

export function getReKYCFlag() {
    return FnxtSingletonApi.get("/kyc/v1/rekyc");
}

export function setReKYCFlag({ payload }) {
    return FnxtSingletonApi.post("/kyc/v1/rekyc", payload);
}

export function checkIBAN(iban) {
    return FnxtSingletonApi.get("/kyc/v1/iban/" + iban);
}

//KYC: Admin
export function getUserKYCDetailsFromAdmin(userid) {
    return FnxtSingletonApi.get("/kyc/v1/admin/user/" + userid);
}

export function enableUserReKYCFromAdmin(userid) {
    return FnxtSingletonApi.post(`/kyc/v1/admin/user/${userid}/rekyc`);
}

export function setManualKYC(payload, kycData) {
    return FnxtSingletonApi.post(
        `/kyc/webhook/manual/${payload.uid}?Tenant=${payload.tenant}&IDNumber=${payload.IDDocumentNumber}&IDIssueDate=${payload.IDIssueDate}&IDExpiryDate=${payload.IDExpiryDate}`,
        kycData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        },
    );
}

export function getBrokerDetails(partnerUuid) {
    return FnxtSingletonApi.get(`/partner/v1/partner/${partnerUuid}`);
}

export function getPartnerListForTenant(tenant) {
    return FnxtSingletonApi.get(`/partner/v1/partners/tenant/${tenant}`);
}

export function updateCommissionStatus(payload) {
    return FnxtSingletonApi.patch(`/partner/v1/commission/status`, payload);
}

export function updateCommissionProvision(payload) {
    return FnxtSingletonApi.patch(`/partner/v1/admin/commission`, payload);
}

export function updatePartnerUsers(partnerUuid, payload) {
    return FnxtSingletonApi.patch(`/partner/v1/admin/partner/${partnerUuid}`, payload);
}

export function sendInvestmentCashlink(payload) {
    return FnxtSingletonApi.post(`/crypto-register/v1/cashlink/send`, payload);
}

export function addProductCashlinkCampaignID(payload) {
    return FnxtSingletonApi.post(`/crypto-register/v1/product/cashlink/campaign`, payload);
}

export function getProductCashlinkCampaignID(payload) {
    return FnxtSingletonApi.post(`/crypto-register/v1/product/cashlink/campaign/get`, payload);
}

export function deleteProductCashlinkCampaignID(payload) {
    return FnxtSingletonApi.delete(`/crypto-register/v1/product/cashlink/campaign/delete`, {}, { data: payload });
}

export function getLionwareByTenant(tenantName) {
    return FnxtSingletonApi.get("/kyc/v1/lionware/" + tenantName);
}

export function createLionware(payload) {
    return FnxtSingletonApi.post("/kyc/v1/lionware", payload);
}

export function checkIfSparkasseUserExists() {
    return FnxtSingletonApi.get("/sachwertinvest/v1/user/exists");
}

export function getSparkasseUserDetails() {
    return FnxtSingletonApi.get("/sachwertinvest/v1/user");
}

export function deleteSparkasseUserBank() {
    return FnxtSingletonApi.delete("/sachwertinvest/v1/user/bank");
}
